'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MortgageOptions() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this._hasChanged = [];
  this._$warning = null;
  this._$hardCheck = null;

  this.init = function () {
    this._super();
  };
  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (this.checkMortgageApplicationEligibility()) {
      if (this.presenter.hasAction('mortgage.update_mortgage_application')) {
        this.presenter.setModelProperty('mortgage._mortgageOptions', this.presenter.models.mortgage.type);
        if (this.presenter.models.mortgage.type !== 'refinance' && !this._isFirstTimeComplete()) this._tray().initializeSecondaryItems();
        this._updateCallback = this.presenter.addCallbackToAction('mortgage.update_mortgage_application', this._onApplicationCreated.bind(this));
      } else {
        this._createCallback = this.presenter.addCallbackToAction('account.create_mortgage_application', this._onApplicationCreated.bind(this));
      }

      // bind to dom elements
      this.$button = this.$node.find('button.primary').on('click.done', this._onDoneClick.bind(this, false)).mogo();
      this.$node.find('#mortgageOptions input').on('change.update-tray', this._onMortgageOptionsChange.bind(this));
      this.$node.find('input').on('change.field-changed', this._onChange.bind(this));
      // warning setup
      this._$warning = $('#mortgage-warning');
      this._$warning.find('.dialog-prompt__confirm').on('click.confirm', this._confirmWaring.bind(this));
      this._$warning.find('.dialog-prompt__cancel').on('click.cancel', this._hideWarning.bind(this));
      // hard check
      this._$hardCheck = $('#mortgage-hardcheck');
      this._$hardCheck.find('.dialog-prompt__confirm').on('click.confirm', this._confirmHardCheck.bind(this));
      this._$hardCheck.find('.dialog-prompt__cancel').on('click.cancel', this._hideHardCheck.bind(this));

      // analyitcs
      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();
    }
  };

  this._onChange = function (ev) {
    var $group = $(ev.target).parents('[data-mogo-ui=BooleanGroup]');
    var prop = $group.attr('name') === 'homePurchaseFirstTime' ? 'is_first_time_home_buyer' : 'type';
    $group.mogo().hideError();
    if (this._hasChanged.indexOf(prop) === -1) this._hasChanged.push(prop);
  };

  this.destroy = function () {
    this._super();

    if (this._$warning) this._$warning.mogo().destroy();
    if (this._$hardCheck) this._$hardCheck.mogo().destroy();

    // reset Models
    this.presenter.resetModels('mortgage');

    // cleanup callbacks
    if (this._updateCallback) this.presenter.removeCallbackFromAction('mortgage.update_mortgage_application', this._updateCallback);
    if (this._createCallback) this.presenter.removeCallbackFromAction('account.create_mortgage_application', this._createCallback);

    if (this._hasChanged.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._hasChanged.join(',')]
      });
    }
  };

  this._onApplicationCreated = function (data, response) {
    if (response === 200) {
      this._hasChanged = [];
      this.presenter.updateModel('mortgage', data);
      this.updateMortgageApplication(this._moveToNextPage.bind(this));
      var analyticsData = this.analytics.constructData('Mortgage Application Started');
      var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
      analyticsRequest.send();
    } else {
      $('#Notification').mogo().get();
      this.$button.removeDisabledLoadState();
    }
  };

  this._moveToNextPage = function () {
    this._tray().moveNext();
    this.$button.removeDisabledLoadState();
  };

  // Converts the model property to a string because the boolean
  // group changes the property to an array
  this._getValue = function (modelProperty) {
    var value = this.presenter.getModelProperty(modelProperty);
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      return value[0];
    }
    return value;
  };

  this._getType = function () {
    var type = this._getValue('mortgage._mortgageOptions');
    if (type !== 'pre_approval') return type;
  };

  this._isFormComplete = function () {
    var result = this._getType();
    if (result === 'home_purchase') result = this._isFirstTimeComplete();
    return result;
  };

  this._isFirstTimeComplete = function () {
    var val = this.presenter.getModelProperty('mortgage.is_first_time_home_buyer');
    return val === true || val === false;
  };

  this._hideHardCheck = function () {
    this._$hardCheck.mogo().hide();
  };

  this._confirmHardCheck = function () {
    this._$hardCheck.mogo().hide();
    this._onDoneClick(true);
  };

  this._hideWarning = function () {
    this._$warning.mogo().hide();
  };

  this._confirmWaring = function () {
    this._$warning.mogo().hide();
    this._onDoneClick(true);
  };

  this._onDoneClick = function (overrideConfimration) {
    if (this._isFormComplete()) {
      // This is a Prompt to show the user that a hard chack that will be performaed
      // This is commented out so that we may add if back if needed
      if (!overrideConfimration && this._createCallback) {
        // Show Hard Check
        this._$hardCheck.mogo().show();
        this.analytics.pushEvent('mortgagePopup', { mortgageUI: ['CreditCheckPopup'] }); // analytics
        $('#mortgage-hardcheck_overlay').attr('data-analytics-id', 'MogoMortgage-Credit Check Popup-Overlay-Null-Click');
        this._$hardCheck.find('.icon--close').attr('data-analytics-id', 'MogoMortgage-Credit Check Popup-Close-Null-Click');
        return;
      }

      // Success
      if (!overrideConfimration && this._hasChanged.length && this.presenter.hasAction('mortgage.update_mortgage_application')) {
        // if this is an update
        var stayedinBuyingHome = this.presenter.models.mortgage.type === 'pre_approval' && this._getType() === 'home_purchase';
        var switchedType = !stayedinBuyingHome && this.presenter.models.mortgage.type !== this._getType();
        if (switchedType) {
          // Show warning
          this._$warning.mogo().show();
          return;
        }
      }

      this.analytics.forcePushEvent('form-submit', {
        FormID: ['MogoMortgage-Form submission-Application Type-null-Form']
      });
      if (this._hasChanged.length === 0) {
        this._tray().moveNext();
      } else {
        var formAction = this.presenter.hasAction('mortgage.update_mortgage_application') ? 'mortgage.update_mortgage_application' : 'account.create_mortgage_application';
        var payLoad = { type: this._getType() };
        if (payLoad.type !== 'refinance') payLoad.is_first_time_home_buyer = this._getValue('mortgage.is_first_time_home_buyer');
        this.$button.setDisabledLoadState();
        this.presenter.performAction(formAction, payLoad);
      }
    } else {
      // Validation error
      var formErrors = [];
      if (!this._getType()) {
        formErrors.push('Type 1');
        this.$node.find('#mortgageOptions').mogo().showErrorLabel();
      } else if (!this._isFirstTimeComplete()) {
        formErrors.push('is_first_time_home_buyer');
        this.$node.find('#homePurchaseFirstTime').mogo().showErrorLabel();
      }
      this.analytics.forcePushEvent('form-errors', { FormErrors: formErrors });
    }
  };

  this._onMortgageOptionsChange = function (event) {
    this._tray().initializeSecondaryItems();
    this.$node.find('#homePurchaseFirstTime').mogo().hideError();
  };
}